export default __webpack_public_path__ + "static/media/ID_Type.52d1b11e.svg";